import { str, cleanEnv } from 'envalid';

const envObj = process.env;

export const environment = cleanEnv(envObj, {
  REACT_APP_API_URL: str(),
});

export default environment;
